module.exports = __webpack_public_path__ + "static/agnico-eagle-logo-04e20473633f75ed6020b4f79871fd14.png";